import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FullPageContent from "../../../components/loading/fullContentLoader";

import PreviewContent from "./Components/PreviewSection";
import CategoryMedia from "./Components/CategoryMedia";

const DetailTargetMediaModule = (props) => {
  const history = useHistory();

  const { dataDetailTargetMedia, loadingDetailTargetMedia } = useSelector(
    (state) => state.service
  );

  return (
    <>
      <div className="card-header p-d-flex p-jc-between p-ai-center">
        <div className="p-d-flex p-jc-start p-ai-center">
          <button onClick={() => history.goBack()} className="button-back">
            <span className="icon-back"></span>
            <div className="mx-4">Kembali</div>
          </button>
        </div>
        <div className="p-d-flex p-jc-start p-ai-center">
          <CategoryMedia item={dataDetailTargetMedia?.targetMedia} />
        </div>
      </div>
      <div className="card-body p-0">
        <div className="article-preview">
          <div className={`section-article no-scroll w-100`}>
            {loadingDetailTargetMedia ? (
              <div className="px-5">
                <FullPageContent />
                <FullPageContent />
              </div>
            ) : (
              <>
                <PreviewContent content={dataDetailTargetMedia?.contentText} />

                <div className="section-article-footer">
                  <div className="write-note">
                    <div className="write-count">
                      {dataDetailTargetMedia?.contentText === ""
                        ? 0
                        : dataDetailTargetMedia?.contentText?.split(" ")
                            .length}{" "}
                      Kata
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailTargetMediaModule;
